module.exports = __webpack_public_path__ + "assets/f00e7e4432f7c70d8c97efbe2c50d43b.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-latin-500-normal.woff2
// module id = 2636
// module chunks = 121